import { OrderableList } from "components/Tables";
import React from "react";
import { ColumnsRow } from "./ColumnsRow";

interface Props {
  columns: server.dto.ExcelTemplateColumn[]
  avaiableMergeFieldTopics: server.dto.AvailableMergeFieldTopic[]
  onOrderChange: (columns: server.dto.ExcelTemplateColumn[]) => void
  onSave: (column: server.dto.ExcelTemplateColumn) => void
  onDelete: (column: server.dto.ExcelTemplateColumn) => void
}

const ColumnsTable = ({ columns, avaiableMergeFieldTopics, onOrderChange, onDelete, onSave }: Props) => {
  const showColumnWarning = columns.length === 0;

  return <>
    <OrderableList
      items={columns}
      getKey={t => t.mergeField}
      render={column => <ColumnsRow column={column} avaiableMergeFieldTopics={avaiableMergeFieldTopics} onSave={onSave} />}
      onOrderChanged={onOrderChange}
      onDelete={onDelete}
    />

    {showColumnWarning &&
      <div className="ui message red">
        <div>{RESX.Template.PleaseAddAColumn}</div>
      </div>
    }
  </>;
};

export default ColumnsTable;